<script>
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { Stack } from "creditdesign-svelte-components";
  import { ImageSlider } from "nature-immersive-svelte-components";

  export let ratio = 0.5625;
  export let imageData = [];
  export let headline;
  export let standFirst;
  export let message;
  export let credit;

  let mounted = false;
  let dispatch = createEventDispatcher();

  onMount(() => {
    mounted = true;
  });

  afterUpdate(() => {
    dispatch("update");
  });
</script>

<style>
  .nature-interactive-graphic {
    padding-top: var(--s4);
    padding-bottom: var(--s4);
  }

  .credit {
    max-width: none;
    padding-bottom: 5px;
    font-size: var(--font-size-small-1);
    color: var(--black-2);
    border-bottom: 1px solid var(--black-3);
  }
</style>

<main class="nature-interactive-graphic">
  <Stack stackSpace="var(--s3)">

    <Stack stackSpace="var(--s-1)">
      <h1>
        {@html headline}
      </h1>
      {@html standFirst}
    </Stack>

    <ImageSlider {ratio} {imageData} {message} bind:mounted />

    <p class="credit">
      {@html credit}
    </p>

  </Stack>
</main>
